import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ProfileComponentEffects } from 'src/app/recruiting/candidates/new-profile/store/profile-component.effects';
import { candidateProfileComponentsReducer } from 'src/app/recruiting/candidates/new-profile/store/profile-component.reducer';
import { profileComponentFeatureKey } from 'src/app/recruiting/candidates/new-profile/store/profile-component.selectors';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(profileComponentFeatureKey, candidateProfileComponentsReducer),
        EffectsModule.forFeature([ProfileComponentEffects])
    ]
})
export class CandidateProfileComponentStoreModule {}
